import React from 'react';

import { Box, Center } from '@chakra-ui/react';
import { AiOutlineDown } from 'react-icons/all';
import { components } from 'react-select';
import { customTheme } from 'theme';

export const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <Box boxSize={4} pr={1}>
        <Center>
          <AiOutlineDown color={customTheme.colors.gray['400']} />
        </Center>
      </Box>
    </components.DropdownIndicator>
  );
};
